import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class FlowlinkOsSupportModel extends IllumioEventEmitter {
    constructor() {
        super();
        // this.dataLoadEvent = new Event(this);
        let url = '/api/v1/pce_software/os_support/flowlink.json'
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/flowlink.json'
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new FlowlinkOsSupportResult();
        result.renderError(null);
    }

        /**
         * Public method
         */
        getRecordByVersion(flowlinkVersion) {
            if (this.data['os_content']) {
                for (let id in this.data['os_content']) {
                    if (this.data['os_content'][id].software_version===flowlinkVersion) {
                        return this.data['os_content'][id];
                    }
                }
            }
            return null;
        }
}


export class FlowlinkOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.flowlinkVersionSelect = document.getElementById('flowlinkVersionSelect');

        this.flowlinkVersionSelect.onchange = this.flowlinkVersionSelectOnChangeHandler.bind(this);

        // this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));
        this.model.on('dataLoad', this.dataLoadEventHandler.bind(this));

        this.result = new FlowlinkOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(id) {
            if (!id && this.flowlinkVersionSelect && this.flowlinkVersionSelect.options.selectedIndex>=0) {
                id = this.flowlinkVersionSelect.options[this.flowlinkVersionSelect.options.selectedIndex].value
            }
            console.debug(`selected id: ${id}`);
            this.result.render(this.model.data['os_content'][id], this.model.data['compatibility'][this.model.data['os_content'][id]['software_version']]);

            location.hash = this.model.data['os_content'][id].software_version;

            this.trackAnalytic();
        }

    flowlinkVersionSelectOnChangeHandler(event) {
        console.debug('flowlinkVersionSelectOnChangeHandler() invoked');
        this.showResult(event.target.value);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            const optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                optionsArray.push(new Option(text, item.id));
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function(a, b) {
                    if (a.text>b.text) {
                        return -1;
                    } else if (a.text<b.text) {
                        return 1;
                    }
                    return 0;
                }
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.flowlinkVersionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler.bind(this));
            }
            if (this.flowlinkVersionSelect.options.length>0) {
                this.defaultFlowlinkVersionSelect();
                this.formDiv.classList.remove('hidden');
                $(this.flowlinkVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    defaultFlowlinkVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            const record = this.model.getRecordByVersion(location.hash.substr(1));
            if (record) {
                for (let i=0;i<this.flowlinkVersionSelect.options.length;i++) {
                    if (this.flowlinkVersionSelect.options[i].text===record.software_version) {
                        found = true;
                        this.flowlinkVersionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.flowlinkVersionSelect.options.selectedIndex = 0;
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.flowlinkVersionSelect.selectedIndex>=0) {
            var eventLabel = this.flowlinkVersionSelect.options[this.flowlinkVersionSelect.selectedIndex].text;
            console.debug(`eventLabel: ${eventLabel}`);
            IllumioSupportUtils.trackGaEvent('OS Support', 'FLOWLINK', eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', 'FLOWLINK Redirect', qs['source'])
            console.debug('Tracked FLOWLINK redirect');
        }
    }
}

export class FlowlinkOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class FlowlinkOsSupportResult {
    constructor() {
        this.flowlinkContent = document.getElementById('flowlinkContent');
    };

        /**
         * Public method
         */
        render(record, compatibility) {
            this.flowlinkContent.innerHTML = this.createCompatibilityTable(record, compatibility);
            this.flowlinkContent.innerHTML += record.view;
            
            this.updateTables();
            thisupdateHeading(record);
        }

        /**
         * Public method
         */
        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.flowlinkContent.innerHTML = message;
        }

    createCompatibilityTable(record, compatibility) {
        let compatability_html = "<h2>COMPATIBILITY</h2>";
        compatability_html += "<table class='ilo-tabular'><tbody><tr><th>Software type</th><th>Version</th></tr><tr><td>PCE</td><td><ul>";
        for (let i in compatibility) {
            compatability_html += `<li>${compatibility[i]}</li>`;
        }
        compatability_html += "</ul></tr></tbody></table>";
        return compatability_html;
    }

    // This code assumes that the last item in the table is the qualified header, and will add the qualified class to the 2nd last column
    updateTables() {
        const tables = $("table");
        tables.addClass('ilo-tabular');
        const table = tables[1];
        const tbody = table.children[1];
        const header = tbody.children[0];
        // Check if the header has 3 items for backwards compatability
        if (!header.children[2]) {
            return;
        }
        let newHTML = "";
        table.style.width = "";

        // There is an unneccasary colgroup in the HTML here
        table.removeChild(table.children[0]);


        // Delete the "qualified" header then grab the rest of it
        header.removeChild(header.children[header.children.length-1]);
        newHTML += header.outerHTML;

        // Start at 1 becuase 0 is the header
        let index = 1
        while (tbody.children[index]) {
            let versions = [];

            do {
                const tr = tbody.children[index];
                if (tr.children.length == header.children.length+1) {
                    versions = versions.sort().reverse();
                    for (let i in versions) {
                        newHTML += `<li class='support-status status-qualified'>${versions[i]}</li>`;
                    }
                    newHTML += "<tr>";
                    for (let i = 0; i < tr.children.length-2; i++) {
                        newHTML += `<td>${tr.children[i].children[0].outerHTML}</td>`;
                    }
                    newHTML += "<td><ul>";
                    versions = [];
                }
                versions.push(tr.children[tr.children.length-2].innerText);
                index += 1;
            } while (tbody.children[index] && tbody.children[index].children.length != 3);
            versions = versions.sort().reverse();
            for (let i in versions) {
                newHTML += `<li class='support-status status-qualified'>${versions[i]}</li>`;
            }
            newHTML += "</ul></td></tr>";
        }
        tbody.innerHTML = newHTML;
    }

    updateHeading(record) {
        const sections = $('.sectionMacroRow');
        for (let i=1;i<sections.length;i++) {
            sections[i].outerHTML += "<br>";
        }

        const headings = document.getElementsByTagName('h2');
        // Don't need to add this text for illumio container solution
        for (let i=0;i<headings.length;i++) {
            if (headings[i].textContent.toLowerCase().indexOf('illumio container solution') < 0) {
                headings[i].textContent += ` for Illumio FLOWLINK ${record.software_version}`;
                console.debug(headings[i].textContent);
            }
        }
    }
}

